module.exports = __webpack_public_path__ + "img/clarity-other.c464a7fb.png";